import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import Select from "react-select";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from '../../../constant';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const WarehouseTransactionMaster = () => {
  const tableHeaders = ["#",  "Transaction Date", "Transaction Type","Created By" ,"Remarks" , "Action"];
   const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
  id: null,
  warehouse_id: 1,
  trxn_date: '',
  trxn_type: '',        
  remarks: '',
    created_by: userId || "",
});

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

 // 🔹 Define options with id/value
const trxnTypeOptions = [
  { value: 1, label: 'IN' },
  { value: 2, label: 'OUT' },
  { value: 3, label: 'WASTAGE' },
  { value: 4, label: 'ADJUSTMENT' },
];

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchData();
    } catch {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart_appstore_inventory_transaction/get`);
      setData(res.data || []);
    } catch {
      toast.error("Failed to fetch transaction data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

 const handleSelectChange = (selectedOption, name) => {
  setFormData(prev => ({ ...prev, [name]: selectedOption?.value || '' }));
  setErrors(prev => ({ ...prev, [name]: '' }));
};
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};


  const handleAddClick = () => {
    setFormData({
      id: null,
      warehouse_id: 1,
      trxn_date: '',
      trxn_type: '',
      remarks: '',
    created_by: userId || "",
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
  const formattedDate = item.trxn_date
    ? new Date(item.trxn_date).toISOString().split("T")[0]
    : "";

  setFormData({
    ...item,
    trxn_date: formattedDate, // ✅ fix here
    trxn_type: Number(item.trxn_type),
  });
  setIsEditMode(true);
  setErrors({});
  setShowModal(true);
};



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    const newErrors = {};
    if (!formData.trxn_date) newErrors.trxn_date = "Transaction date is required";
    if (!formData.trxn_type) newErrors.trxn_type = "Transaction type is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}veemart_appstore_inventory_transaction/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}veemart_appstore_inventory_transaction/post`, formData);
      }
      toast.success(res?.data?.message || "Transaction saved successfully!");
      setShowModal(false);
      fetchData();
    } catch (err) {
      if (err?.response?.data?.errors) setErrors(err.response.data.errors);
      toast.error(err?.response?.data?.message || "Failed to save transaction");
    } finally {
      setLoading(false);
    }
  };

 const getLabel = (options, value) => {
  if (!options || !Array.isArray(options)) return "-"; // ✅ Safe guard
  const found = options.find(o => String(o.value) === String(value));
  return found ? found.label : "-";
};




 const filteredData = data.filter(item => {
  const search = searchQuery.toLowerCase();
  return (
    (item.trxn_date && formatDate(item.trxn_date).toLowerCase().includes(search)) ||
    (item.remarks && item.remarks.toLowerCase().includes(search)) ||
    (getLabel(trxnTypeOptions, item.trxn_type).toLowerCase().includes(search)) ||
    (userName && userName.toLowerCase().includes(search))
  );
});


  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search transaction..."
                  value={searchQuery}
                  onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan={tableHeaders.length} className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                         <td>{formatDate(item.trxn_date)}</td>
<td>{getLabel(trxnTypeOptions, item.trxn_type)}</td>
                          <td>{userName || "-"}</td>

                          <td>{item.remarks}</td>
                          <td className="text-center">
                            <Link
                                                        to="#"
                                                        className="btn shadow btn-xs sharp me-1"
                                                        style={{ backgroundColor: "#007bff", color: "white" }}
                                                        onClick={() => handleEditClick(item)}
                                                      >
                                                        <i className="fas fa-pencil-alt"></i>
                                                      </Link>

                                                       <button
                          className="btn shadow btn-xs sharp"
                          style={{ backgroundColor: "#ef5c0dff", color: "white" }}
                          title="View details"
                          onClick={() => {
                            localStorage.setItem("transac_id", item.id);
                            localStorage.setItem(
                              "transac_type",
                              item.trxn_type
                            );
                             localStorage.setItem("transac_date", item.trxn_date);
        localStorage.setItem("reference_number", item.reference_number);
                            navigate(
                              `/appstore-transaction-details?transac_id=${encodeURIComponent(
                                item.id
                              )}`
                            );
                          }}
                        >
                          <i className="fas fa-file-invoice"></i>
                        </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Transaction" : "Add Transaction"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
               

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Transaction Date <span className="text-danger">*</span></Form.Label>
                    <Form.Control type="date" name="trxn_date" value={formData.trxn_date} onChange={handleInputChange} />
                    {errors.trxn_date && <div className="text-danger small mt-1">{errors.trxn_date}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Transaction Type <span className="text-danger">*</span></Form.Label>
                    <Select
                      options={trxnTypeOptions}
                      value={trxnTypeOptions.find(o => o.value === formData.trxn_type) || null}
                      onChange={(option) => handleSelectChange(option, 'trxn_type')}
                      isSearchable
                      placeholder="Select transaction type"
                    />
                    {errors.trxn_type && <div className="text-danger small mt-1">{errors.trxn_type}</div>}
                  </Form.Group>
                </Col>

               

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control type="text" name="remarks" value={formData.remarks} onChange={handleInputChange} placeholder="Enter remarks" />
                  </Form.Group>
                </Col>

              
              </Row>

              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Creating...</> : "Create"}
                    </Button>
                    <Button variant="danger" type="reset" onClick={handleAddClick} disabled={loading}>Reset</Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Updating...</> : "Update"}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>Cancel</Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>

      <ToastContainer />
    </>
  );
};

export default WarehouseTransactionMaster;
